import { useCallback, useLayoutEffect, useRef } from "react";
function throwUnsupportedError() {
    throw new Error("Cannot call an event handler while rendering.");
}
/**
 * Alternative version of `useCallback` without dependencies.
 * @see https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * @param fn
 * @returns
 */
export function useEventCallback(fn) {
    const ref = useRef(throwUnsupportedError);
    useLayoutEffect(() => {
        ref.current = fn;
    });
    return useCallback((...args) => (0, ref.current)(...args), []);
}
//# sourceMappingURL=useEventCallback.js.map